import UserTransfer from 'components/UserTransfer/List/UserTransfer';

const UserTransferPageList = () => {
	return <UserTransfer />;
};

export default UserTransferPageList;
